module.exports = __webpack_public_path__ + "static/03-07288e0138a630cb1f57c5d4741aedad.jpg";